var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social-facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--on-surface)",
    d: "M.5 12c0 5.692 4.14 10.407 9.602 11.385l.069-.056c-.004 0-.007 0-.011-.002V15.22H7.285V12h2.875V9.47c0-2.875 1.84-4.485 4.485-4.485.805 0 1.725.115 2.53.23v2.933H15.68c-1.38 0-1.725.69-1.725 1.61V12h3.048l-.518 3.22h-2.53v8.107l-.105.02.048.038C19.36 22.407 23.5 17.692 23.5 12 23.5 5.675 18.325.5 12 .5S.5 5.675.5 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social-facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSocialFacebook;